import { render, staticRenderFns } from "./SwitchOrdersExplorer.vue?vue&type=template&id=3e0e1e7d&scoped=true"
import script from "./SwitchOrdersExplorer.vue?vue&type=script&lang=js"
export * from "./SwitchOrdersExplorer.vue?vue&type=script&lang=js"
import style0 from "./SwitchOrdersExplorer.vue?vue&type=style&index=0&id=3e0e1e7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e0e1e7d",
  null
  
)

export default component.exports